import axios from 'axios';
// import { cacheAdapterEnhancer } from 'axios-extensions';

const apiHttp = axios.create({
  baseURL: process.env.EGW_API_HOST,
  // adapter: cacheAdapterEnhancer(axios.defaults.adapter, { enabledByDefault: false, cacheFlag: 'useCache' }),
});

export default apiHttp;



// WEBPACK FOOTER //
// ./src/apiHttp.js